export function randomId(): string {
  return Math.round(Math.random() * 100000 + 100000).toString(10);
}
